import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import axios from "../../axios-vmou";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import styles from "./bill.module.css";
import { Dropdown } from "primereact/dropdown";
import Navbar from "../main/navbar";
import logo from "../../assets/vmou.png";
import { useHistory } from "react-router-dom";
import * as actions from '../../store/actions/index'
import { Sidebar } from 'primereact/sidebar';

const Bill = (props) => {
  const [visibleRight, setVisibleRight] = useState(false);
  const onSignout = () => {
    props.onlogout();
  }
  let emptyBill = {
    userid:'',
    examinerid: "",
    billno: "",
    billdate: "",
    gross: "",
    swf: "",
    tds: "",
    netamt: "",
    batches: "",
  };
  const exams = [
    "DEC25",
    "JUNE25",
    "DEC24"

  ]

  const [bill, setBill] = useState(emptyBill);
  const [bills, setbills] = useState([]);
  const [selectedbills, setSelectedbills] = useState(null);
  const [BillDialog, setBillDialog] = useState(false);
  const [deleteBillDialog, setDeleteBillDialog] = useState(false);
  const [selectedExam, setSelectedExam ] = useState('DEC25');
  const [globalFilter, setGlobalFilter] = useState(null);
  const toast = useRef(null);
  const dt = useRef(null);
  const history = useHistory()

  useEffect(() => {
    let authOptions = {
      method: 'PUT',
      url: '/bill/ByExaminer/', 
      data: {'examinerid':props.userid,'exam':selectedExam},
      headers : {
          'x-auth-token' : localStorage.getItem('token')
      }
    };
    axios(authOptions)
    .then(response => {
      setbills(response.data);
    })
    .catch(error => {
      toast.current.show({severity: 'error', summary: 'Error Message', detail: error.response.data});
    });
},[props.userid,selectedExam]); 

  const billsearch = (event) => {
    event.preventDefault();  
    billsearchmodule();
  }
  const billsearchmodule = () => {
    let authOptions = {
      method: 'PUT',
      url: '/bill/ByExaminer/', 
      data: {'examinerid':props.userid,'exam':selectedExam},
      headers : {
          'x-auth-token' : localStorage.getItem('token')
      }
    };
    axios(authOptions)
    .then(response => {
      setbills(response.data);
    })
    .catch(error => {
      toast.current.show({severity: 'error', summary: 'Error Message', detail: error.response.data});
    });
  }

  const saveBill = (event) => {
    event.preventDefault();
    let authOptions = {
      method: 'POST',
      url: '/bill/', 
      data: {'examinerid':props.userid,'exam':selectedExam},
      headers : {
          'x-auth-token' : localStorage.getItem('token')
      }
    };
    axios(authOptions)
    .then(response => {
      const _bills = [...bills];
      _bills.push(response.data);
      setbills(_bills);
      billsearchmodule();
    })
    .catch(error => {
      toast.current.show({severity: 'error', summary: 'Error Message', detail: error.response.data});
    });
  }
  
  const hideDialog = () => {
    setBillDialog(false);
  };

  const hideDeleteBillDialog = () => {
    setDeleteBillDialog(false);
  };

  const printBill = (bill) => {
    history.push({
      pathname: '/BillPrint',
      state: {bill:bill}
  });
};

  const confirmDeleteBill = (dbill) => {
    setBill(dbill);
    setDeleteBillDialog(true);
  };


  const deleteBill = () => {
    let authOptions = {
      method: "put",
      url: "/bill/billdelete/",
      data: bill,
      headers: {
        "x-auth-token": localStorage.getItem("token"),
      },
    };
    axios(authOptions)
      .then((response) => {
        setDeleteBillDialog(false);
        setbills([...bills].filter(x => x.billno !== bill.billno));
        setBill(emptyBill);
        toast.current.show({
          severity: "success",
          summary: "Successful",
          detail: "Bill Removed",
          life: 3000,
        });
      })
      .catch((error) => {
        toast.current.show({
          severity: "error",
          summary: "Error Message",
          detail: error.response.data,
        });
      });
  };


  const exportCSV = () => {
    dt.current.exportCSV();
  };


  // const isAdminBodyTemplate = (rowData) => {
  //     return (rowData.isAdmin?<span >True</span>:<span >False</span> );
  // }

  const actionBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        <Button
          icon="pi pi-print"
          className="p-button-rounded p-button-text p-button-success p-mr-2"
          onClick={() => printBill(rowData)}
        />
        <Button
          icon="pi pi-trash"
          className="p-button-rounded p-button-text p-button-warning"
          onClick={() => confirmDeleteBill(rowData)}
        />
      </React.Fragment>
    );
  };

  const header = (
    <div className={styles.tableheader}>
      <h4 className="mx-0 my-1">Manage bills</h4>
      <Button
          label="New"
          icon="pi pi-plus"
          className="p-button-success p-mr-2"
          onClick={saveBill}
        />
        <Button
          label="Export"
          icon="pi pi-upload"
          className="p-button-help"
          onClick={exportCSV}
        />
        <span className="p-input-icon-left">
        <i className="pi pi-search" />
        <InputText
          type="search"
          onInput={(e) => setGlobalFilter(e.target.value)}
          placeholder="Search..."
        />
      </span>
    </div>
  );
  const BillDialogFooter = (
    <React.Fragment>
      <Button
        label="Cancel"
        icon="pi pi-times"
        className="p-button-text"
        onClick={hideDialog}
      />
      <Button
        label="Generate"
        icon="pi pi-check"
        className="p-button-text"
        onClick={saveBill}
      />
    </React.Fragment>
  );
  const deleteBillDialogFooter = (
    <React.Fragment>
      <Button
        label="No"
        icon="pi pi-times"
        className="p-button-text"
        onClick={hideDeleteBillDialog}
      />
      <Button
        label="Yes"
        icon="pi pi-check"
        className="p-button-text"
        onClick={deleteBill}
      />
    </React.Fragment>
  );

  const formatDate = (dt) => {
    let cdt = new Date(dt);
    let month = cdt.getMonth() + 1;
    let day = cdt.getDate();
    if (month < 10) {
        month = '0' + month;
    }
    if (day < 10) {
        day = '0' + day;
    }
    return (dt)?day+"-"+month+"-"+cdt.getFullYear():'' ;
  };


  const dateBodyTemplate = (rowData) => formatDate(rowData.billdate);
  const grossBodyTemplate = (rowData) => rowData.gross.toFixed(2);
  const swfBodyTemplate = (rowData) => rowData.swf.toFixed(2);
  const tdsBodyTemplate = (rowData) => rowData.tds.toFixed(2);
  const netBodyTemplate = (rowData) => rowData.netamt.toFixed(2);

  return (
    <div className={styles.datatablecruddemo}>
      <Toast ref={toast} />
        <Sidebar className="flex align-items-center " visible={visibleRight} position="right" onHide={() => setVisibleRight(false)}>
          <h2>User Profile....</h2>
          <h5>Examiner ID : {props.email}</h5>
          <h5>Name        : {props.username}</h5>
          <Button className="p-button-text p-button-danger ml-4" style={{}} onClick={onSignout}>Sign Out</Button>
        </Sidebar>
      <div className="Headerusr" style={{ position: "sticky" }}>
        <img
          src={logo}
          alt="VMOU"
          height={100}
          width={90}
          style={{ margin: "0px 0 0 20px" }}
        ></img>
        <h2 style={{ marginTop: "0", textAlign: "center" }}>
          Bill Module
          <br />
          Bill Management
        </h2>
        <div className="Userusr" onClick={(e) => setVisibleRight(true)}>
          <i
            style={{ fontSize: "1.5em" }}
            className="pi pi-user mr-6 mt-2 text-right"
          ></i>
          <h4 style={{ margin: "0 30px 0 0", textAlign: "end" }}>
            Hi, {props.username}
          </h4>
        </div>
      </div>
      <Navbar />
      <div className={styles.Sformpr}>
            <div className=" ">
                <label htmlFor="centre" className="">Select Exam</label>
                <Dropdown className="ml-4 my-1 h-auto" value={selectedExam} options={exams} onChange={(e) => setSelectedExam(e.value)}  placeholder="Select Exam" />
            </div>
            <Button icon="pi pi-search" className="ml-4 p-button-text p-button-success" onClick={billsearch}/>
      </div>
      <div className={styles.card}>

        <DataTable
          resizableColumns
          columnResizeMode="fit"
          showGridlines
          className="p-datatable-sm"
          ref={dt}
          value={bills}
          selection={selectedbills}
          onSelectionChange={(e) => setSelectedbills(e.value)}
          dataKey="email"
          sortField="email"
          sortOrder={1}
          paginator
          rows={10}
          rowsPerPageOptions={[5, 10, 25]}
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords} bills"
          globalFilter={globalFilter}
          header={header}
          responsiveLayout="scroll"
        >
          <Column
            field="billno"
            header="Bill No"
            sortable
            style={{width: "15%" , textAlign:"center",padding:'0 1px 0 4px' }}
          ></Column>
          <Column
            field="billdate"
            header="Date"
            body={dateBodyTemplate}
            sortable
            style={{ textAlign:'center',width: "15%"  , padding:'0 1px 0 1px'}}
          ></Column>
          <Column
            field="gross"
            header="Gross Amt"
            body={grossBodyTemplate}
            style={{ textAlign:'right',width: "15%" , padding:'0 20px 0 1px' }}
          ></Column>
          <Column
            field="swf"
            header="S.W.F"
            body={swfBodyTemplate}
            style={{textAlign:'right', width: "15%" , padding:'0 20px 0 1px' }}
          ></Column>
          <Column
            field="tds"
            header="T.D.S"
            body={tdsBodyTemplate}
            style={{ textAlign:'right',width: "15%" , padding:'0 20px 0 1px' }}
          ></Column>
          <Column
            field="netamt"
            header="Net Payable"
            body={netBodyTemplate}
            style={{ textAlign:'right', width: "15%"  , padding:'0 20px 0 1px'}}
          ></Column>
          <Column
            body={actionBodyTemplate}
            exportable={false}
            style={{  padding:'0 1px 0 20px'}}
          ></Column>
        </DataTable>
      </div>

      <Dialog
        visible={BillDialog}
        style={{ width: "550px" }}
        header="Generate New Bill"
        modal
        className="p-fluid"
        footer={BillDialogFooter}
        onHide={hideDialog}
      >
        <div className={styles.confirmationcontent}>
          <i
            className="pi pi-exclamation-triangle p-mr-3"
            style={{ fontSize: "2rem" }}
          />
          {Bill && (
            <span>
              This will Generate bill For All Submitted Batches. Are You Sure ?
            </span>
          )}
        </div>
      </Dialog>

      <Dialog
        visible={deleteBillDialog}
        style={{ width: "450px" }}
        header="Confirm"
        modal
        footer={deleteBillDialogFooter}
        onHide={hideDeleteBillDialog}
      >
        <div className={styles.confirmationcontent}>
          <i
            className="pi pi-exclamation-triangle p-mr-3"
            style={{ fontSize: "2rem" }}
          />
          {Bill && (
            <span>
              Are you sure you want to Remove this Bill Permanently ? <b>{Bill.billno}</b>?
            </span>
          )}
        </div>
      </Dialog>
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    username: state.auth.username,
    userid: state.auth.userid,
    email: state.auth.email,
    isAuth: state.auth.token !== null,
  };
};

const mapDispatchToProps = dispatch => {
  return {
      onlogout:() => dispatch(actions.logout())
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Bill);